<template>
    <div class="loader-container">
        <div class="check"></div>
    </div>
</template>

<script>

export default {
    name: 'CheckedMark',
    data () {
        return {}
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.check {
    border: none;
    border-left: none;
    width: 20px;
    content: "";
    height: 50px;
    transform-origin: left top;
    // animation: check 0.5s ease;
    border-top: 4px solid #02a802;
    border-right: 4px solid #02a802;
    transform: scaleX(-1) rotate(135deg);
}

@media (max-width: 698px) { // Gertec SK210
    .check {
        width: 8px !important;
        height: 25px !important;
        animation: check-sm 0.5s ease;
    }
    @keyframes check-sm {
        0% {
            height: 0;
            width: 0;
            opacity: 1;
        }

        20% {
            height: 0;
            width: 8px;
            opacity: 1;
        }

        100% {
            height: 25px;
            width: 8px;
            opacity: 1;
        }
    }
}
@keyframes check {
    0% {
        height: 0;
        width: 0;
        opacity: 1;
    }

    20% {
        height: 0;
        width: 20px;
        opacity: 1;
    }

    100% {
        height: 50px;
        width: 20px;
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckedMark.vue